import React, { Component } from 'react';

// import Circles from '../../components/Circles';
import FooterAbout from '../../components/FooterAbout';
import PathContext from "../../context/path";
import styles from './About.module.sass';
// import './img/main.bg.png';

class About extends Component {
	state = {
	}
	static contextType = PathContext;
	path = this.context;
	componentDidMount() {
		window.scrollTo(0, 0);

	}
	render() {

		return <div className={styles.wrap}>
			<div className={styles.bg1}>
				<picture>
					<source media="(min-width: 768px)" srcSet={`${this.path}/img/about-bg-desktop.png`} />
					<img src={`${this.path}/img/about-bg.png`} alt="" />
				</picture>
			</div>
			<div className={styles.inner}>
				<div className="container">
					<h1 className={styles.title}>About the project</h1>
					<div className={styles.text} data-aos="fade-up">
						<p>HIV is a global problem, but it is getting rampant in Russia. One of the key reasons is the lack of awareness and the taboo nature of the topic.</p>
						<p>According to the UN, Russia has one of the fastest growing HIV/AIDS epidemics in the world. Approximately 95,000 Russians were diagnosed with HIV in 2015, and approximately 75,000 in the first nine months of 2016. Stigma surrounding the disease, and government indifference have contributed to the crisis. </p>
						<p>This is the social project initiated by the Infografika Agency. We made the project together with the AIDS.CENTER Foundation experts.</p> 
						<p>The project tells about the real audience of the virus and disease statistics. The information is presented so that people think that each of us can have this virus. The main aim of the project is to give awareness to the problem. </p>
						<p>The project is timed to match with World AIDS Day — December 01.</p>
					</div>
					<div className={styles.body}>
						<div className={styles.command}>
							<div className={styles.command_title}   data-aos="fade-up">Project team</div>
							<div   data-aos="fade-up">
							<div className={styles.people}>
								<span>Author of the idea: </span>
								<span>Nikolay Romanov</span>
							</div>
							<div className={styles.people}>
								<span>Project manager: </span>
								<span>Anna Kuznetsova</span>
							</div>
							<div className={styles.people}>
								<span>Designer: </span>
								<span>Lesya Balashova</span>
							</div>
							<div className={styles.people}>
								<span>Web-development: </span>
								<span>Alexey Kalinovsky</span>
							</div>
							<div className={styles.people}>
								<span>Text:  </span>
								<span>Nikolay Romanov, Anna Kuznetsova, Lesya Balashova</span>
							</div>
							<div className={styles.people}>
								<span>Editor: </span>
								<span>Kliment Lysenko</span>
							</div>
							<div className={styles.people}>
								<span>Illustrator: </span>
								<span>Elizaveta Romanova</span>
							</div>
							<div className={styles.people}>
								<span>Animation: </span>
								<span>Anar Surutaeva</span>
							</div>
							<div className={styles.people}>
								<span>Art director: </span>
								<span>Artem Koleganov</span>
							</div>
							<div className={styles.people}>
								<span>Marketing: </span>
								<span>Fedor Anisimov</span>
							</div>
						</div>
						</div>

						<div className={styles.sources}>

							<div className={styles.sources_title}   data-aos="fade-up">Sources</div>
							<div   data-aos="fade-up">
							<div className={styles.source}>
								<a className={styles.link} href="http://www.hivrussia.info/dannye-po-vich-infektsii-v-rossii/" rel="noreferrer" target="_blank">Federal Scientific and Methodological Center for the Prevention and Control of AIDS</a>
							</div>
							<div className={styles.source}>
								<a className={styles.link} href="https://spid.center/ru/posts/4243/" rel="noreferrer" target="_blank">AIDS.CENTER Foundation</a>
							</div>
							<div className={styles.source}>
								<a className={styles.link} href="https://www.unaids.org/ru/frequently-asked-questions-about-hiv-and-aids" rel="noreferrer" target="_blank">UNAIDS</a>
							</div>
							<div className={styles.source}>
								<a className={styles.link} href="https://fedstat.ru/indicator/43700 " rel="noreferrer" target="_blank">United Interdepartmental Information and Statistical System</a>
							</div>
							<div className={styles.source}>
								<a className={styles.link} href="https://www.thelancet.com/action/showPdf?pii=S0140-6736%2819%2930418-0" rel="noreferrer" target="_blank">PARTNER research</a>
							</div>
						</div>
						</div>
					</div>

				</div>
			</div>
			{/* footer */}
			<div className={styles.footer}>

				<FooterAbout />
			</div>
		</div>;
	}
}

export default About;
